import {Injectable} from '@angular/core';
import {RestServiceAbstract} from "../../abstracts/rest-service.abstract";
import {map, takeUntil} from "rxjs/operators";
import {Observable, Subject} from "rxjs";
import {SetCredentialsTokenRequest} from "../../models/registration/set-credentials-token-request.model";
import {ICredentialsService} from "../../interfaces/credentials-service.interface";
import {Response} from "../../models/response.model";

@Injectable({
    providedIn: 'root'
})
export class PasswordRestService extends RestServiceAbstract implements ICredentialsService{

    public ngUnsubscribe$: Subject<void> = new Subject<void>();

    /**
     * @param {Object} r
     * @returns {Observable<Object>}
     */
    public initPasswordReset(r: Object): Observable<Response> {
        return this.post(`/usermanagement/passwordReset/init`, r).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            })
        );
    }

    /**
     * @returns {Observable<Response>}
     */
    public setCredentials(scr: SetCredentialsTokenRequest): Observable<Response> {
        return this.post(`/usermanagement/passwordReset/setCredentials`, scr).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            })
        );
    }

    /**
     * @returns{
     * @param {string} token
     * @returns {Observable<Response>}
     */
    public confirm(token: string): Observable<Response> {
        return this.get(`/usermanagement/passwordReset/confirm`, {params: {token: token}}).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            })
        );
    }

    /**
     * Unsubscribe from all subscriptions.
     */
    ngOnDestroy(): void {
        // This aborts all HTTP requests.
        this.ngUnsubscribe$.next();
        // This completes the subject properly.
        this.ngUnsubscribe$.complete();
    }
}
